import scenarios from './classifying-together-scenarios'

const answers = {
	'rule-based': 'Rule-based',
	'data-driven': 'Data-driven',
}

const followUps = {
	'rule-based': 'What would be the rules, or instructions, for this scenario?',
	'data-driven': 'What examples would be in the dataset for the AI system to learn patterns from?',
}

const shuffle = (list) => {
	const copy = [...list]
	for (let i = copy.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1))
		;[copy[i], copy[j]] = [copy[j], copy[i]]
	}
	return copy
}

const placeholder = (emoji) =>
	'data:image/svg+xml;charset=utf-8,' +
	encodeURIComponent(
		`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 260"><rect width="800" height="260" fill="#e3e9f4"/><text x="400" y="130" font-size="120" text-anchor="middle" dominant-baseline="central">${emoji}</text></svg>`,
	)

export default function classifyingTogether() {
	return {
		answers,
		followUps,
		screen: 'start',
		deck: [],
		index: 0,
		choice: null,
		answered: false,
		explained: false,
		score: 0,
		missed: [],

		get total() {
			return this.deck.length
		},

		get card() {
			return this.deck[this.index] ?? null
		},

		get correct() {
			return this.answered && this.choice === this.card.answer
		},

		get isLast() {
			return this.index === this.total - 1
		},

		otherAnswer(scenario) {
			return scenario.answer === 'rule-based' ? answers['data-driven'] : answers['rule-based']
		},

		image(scenario) {
			return scenario.image || placeholder(scenario.emoji)
		},

		start() {
			this.deck = shuffle(scenarios)
			this.index = 0
			this.choice = null
			this.answered = false
			this.explained = false
			this.score = 0
			this.missed = []
			this.screen = 'play'
			this.focus('question')
		},

		pick(answer) {
			if (this.answered || !answers[answer]) {
				return
			}

			this.choice = answer
			this.answered = true
			if (answer === this.card.answer) {
				this.score += 1
			} else {
				this.missed = [...this.missed, this.card]
			}
			this.focus('followUp')
		},

		explain() {
			if (!this.answered || this.explained) {
				return
			}

			this.explained = true
			this.focus('next')
		},

		next() {
			if (!this.explained) {
				return
			}

			if (this.isLast) {
				this.screen = 'results'
				this.focus('results')
				return
			}

			this.index += 1
			this.choice = null
			this.answered = false
			this.explained = false
			this.focus('question')
		},

		focus(ref) {
			this.$nextTick(() => requestAnimationFrame(() => this.$refs[ref]?.focus()))
		},
	}
}
